import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/auth/login";
import Portfolio from "./pages/portfolio/interface/portfolio";
import Dashboard from "./pages/dashboard/Dashboard";
// import Home from "./pages/home/home";
import Home from "./pages/home/interface/home";
import Multibaggers from "./pages/multibaggers/interface/multibagger";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ETF from "./pages/etf/ETF";

// Route guard component
const ProtectedRoute = ({ isAuthenticated, children }) => {
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};


const GuestRoutes = () => {
  const navigate = useNavigate();
  const authState = useSelector(state => state.auth.authState)
  // useEffect(() => {
  //   if (authState) {
  //     navigate("/login")
  //   }
  // }, [])
  return (
    <Routes>
      <Route
        path="/login"
        element={
          authState ? <Navigate to="/dashboard" replace /> : <Login />
        }
      />
      {/* <Route
        path="/home"
        element={
          <ProtectedRoute isAuthenticated={authState}>
            <Home />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="/"
        element={
          // <Home />
          authState ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/portfolio"
        element={
          <ProtectedRoute isAuthenticated={authState}>
            <Portfolio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute isAuthenticated={authState}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/multibagger"
        element={
          <ProtectedRoute isAuthenticated={authState}>
            <Multibaggers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/etf"
        element={
          <ProtectedRoute isAuthenticated={authState}>
            <ETF />
          </ProtectedRoute>
        }
      />
      {/* Catch-all route for unmatched paths */}
      <Route
        path="*"
        element={
          authState ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
        }
      />
    </Routes>
  );
};

export default GuestRoutes;


// import { Navigate, Route, Routes } from "react-router-dom";
// import { useSelector } from "react-redux";

// import Login from "./pages/auth/login";
// import Home from "./pages/home/home";
// import Portfolio from "./pages/portfolio/index";
// import Dashboard from "./pages/dashboard/index";
// import Multibaggers from "./pages/multibaggers/index";

// // Enhanced ProtectedRoute component
// const ProtectedRoute = ({ isAuthenticated, userDetail, children, path }) => {
//   // const shouldCheckUserDetail = path !== "/login" && path !== "/dashboard";

//   const hasRequiredUserDetails =
//     userDetail?.wealthInvestmentAmt && userDetail?.multibaggerAllocation;

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if ( !hasRequiredUserDetails) {
//     return <Navigate to="/dashboard"  />;
//   }

//   return children;
// };

// const GuestRoutes = () => {
//   const authState = useSelector((state) => state.auth.authState);
//   const userDetail = useSelector((state) => state.auth.userDetail); // Ensure this exists in your Redux store

//   return (
//     <Routes>
//       <Route
//         path="/login"
//         element={
//           authState ? <Navigate to="/dashboard" replace /> : <Login />
//         }
//       />
//       <Route
//         path="/portfolio"
//         element={
//           <ProtectedRoute
//             isAuthenticated={authState}
//             userDetail={userDetail}
//             path="/portfolio"
//           >
//             {/* You can change Home to Portfolio when needed */}
//             <Home />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/dashboard"
//         element={
//           <ProtectedRoute
//             isAuthenticated={authState}
//             userDetail={userDetail}
//             path="/dashboard"
//           >
//             <Dashboard />
//           </ProtectedRoute>
//         }
//       />
//       <Route
//         path="/multibagger"
//         element={
//           <ProtectedRoute
//             isAuthenticated={authState}
//             userDetail={userDetail}
//             path="/multibagger"
//           >
//             <Multibaggers />
//           </ProtectedRoute>
//         }
//       />
//       {/* Catch-all route */}
//       <Route
//         path="*"
//         element={
//           authState ? (
//             <Navigate to="/dashboard" replace />
//           ) : (
//             <Navigate to="/login" replace />
//           )
//         }
//       />
//     </Routes>
//   );
// };

// export default GuestRoutes;
